import { Link } from 'react-router-dom';

const ContactBanner = () => {
  return (
    <section className="py-20 bg-[#F8FAFC] border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left */}
          <div>
            <span className="text-[#DC2626] text-xs font-semibold tracking-widest uppercase">Bereit loszulegen?</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-3 mb-5 leading-tight">
              Ihr nächstes Projekt beginnt mit einem Gespräch
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-8">
              Schildern Sie uns Ihre Anforderungen – wir melden uns innerhalb von 24 Stunden mit einer ersten Einschätzung. Kostenlos und unverbindlich.
            </p>
            <Link
              to="/anfrage"
              className="inline-flex items-center gap-2 bg-[#DC2626] hover:bg-[#b91c1c] text-white font-semibold px-8 py-4 rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Jetzt Projekt anfragen
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
            </Link>
          </div>

          {/* Right: Contact Info */}
          <div className="flex flex-col gap-4">
            <div className="bg-white rounded-xl p-6 border border-gray-100 flex items-center gap-5">
              <div className="w-12 h-12 flex items-center justify-center bg-[#EFF6FF] rounded-xl shrink-0">
                <i className="ri-phone-line text-[#1E3A8A] text-xl"></i>
              </div>
              <div>
                <div className="text-gray-400 text-xs mb-1">Telefon</div>
                <a href="tel:+491776512122" className="text-gray-900 font-semibold text-base hover:text-[#1E3A8A] transition-colors cursor-pointer">
                  +49 1776512122
                </a>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 border border-gray-100 flex items-center gap-5">
              <div className="w-12 h-12 flex items-center justify-center bg-[#EFF6FF] rounded-xl shrink-0">
                <i className="ri-mail-line text-[#1E3A8A] text-xl"></i>
              </div>
              <div>
                <div className="text-gray-400 text-xs mb-1">E-Mail</div>
                <a href="mailto:anfrage@gowitec.de" className="text-gray-900 font-semibold text-sm hover:text-[#1E3A8A] transition-colors cursor-pointer break-all">
                  anfrage@gowitec.de
                </a>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 border border-gray-100 flex items-center gap-5">
              <div className="w-12 h-12 flex items-center justify-center bg-[#EFF6FF] rounded-xl shrink-0">
                <i className="ri-map-pin-line text-[#1E3A8A] text-xl"></i>
              </div>
              <div>
                <div className="text-gray-400 text-xs mb-1">Adresse</div>
                <address className="not-italic text-gray-900 font-medium text-sm leading-relaxed">
                  Gewerbeparkstr. 8, 51580 Reichshof-Wehnrath
                </address>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactBanner;
